import React, { ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import { Field, FieldArray, WrappedFieldArrayProps } from 'redux-form';
import SelectFormField from '../../../../shared/forms/fields/SelectFormField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import MenuItem from '@mui/material/MenuItem';
import MultiTextFormField from '../../../../shared/forms/fields/MultiTextFormField';
import { parseMultiNumberFieldValue } from '../../../../shared/forms/utils/parseNumberFieldValue';

type MtProps = {
  fields: Object[],
  meta: { error: ReactNode, submitFailed: Boolean },
  readOnly: boolean,
  readonly smscIdList: string[];
  //change: Function,
}

const renderMtRouting = ({
  fields,
  meta: { error, submitFailed },
  readOnly,
  smscIdList,
  //change,
}: WrappedFieldArrayProps<any> & MtProps) => (

  <div>
    {!readOnly && (
      <>
        <Button size='small' onClick={() => fields.push({})}>
          Add MT Routing
        </Button>
        <Divider />
      </>
    )}
    {submitFailed && error && <span>{error}</span>}

    {fields.map((route, index) => (
      <Paper key={index} style={{ padding: '25px', marginBottom: '10px' }}>
        <Grid container spacing={2}>
          <Grid item xs={11}>
            <Field
              format={(value: String) => value || []}
              fullWidth
              disabled={readOnly}
              label='SMSC'
              name={`${route}.smscIds`}
              component={SelectFormField}
              multiple={true}
            >
              { smscIdList.map(smscId => (
                <MenuItem key={smscId} value={smscId}>{smscId}</MenuItem>
              ))}
            </Field>
          </Grid>
          <Grid item xs={1}>
            <IconButton
              disabled={readOnly}
              onClick={() => fields.remove(index)}
              style={{ marginTop: '7px' }}
            >
              <DeleteForeverIcon />
            </IconButton>
          </Grid>
          <Grid item xs={12}>
            <Field
              fullWidth
              disabled={readOnly}
              label='Prefixes'
              name={`${route}.receiverPrefixes`}
              placeholder='e.g. 33'
              component={MultiTextFormField}
              parse={parseMultiNumberFieldValue}
            />
          </Grid>
        </Grid>
      </Paper>
    ))}
  </div>
);

type MoProps = {
  readonly fields: Object[],
  readonly meta: { error: ReactNode, submitFailed: Boolean },
  readonly readOnly: boolean,
  readonly smscIdList: string[];
  //change: Function,
}

const renderMoRouting = ({
  fields,
  meta: { error, submitFailed },
  readOnly,
  smscIdList,
  //change,
}: WrappedFieldArrayProps<any> & MoProps) => (
  <div>
    {!readOnly && (
      <>
        <Button size='small' onClick={() => fields.push({})}>
          Add MO Routing
        </Button>
        <Divider />
      </>
    )}
    {submitFailed && error && <span>{error}</span>}

    {fields.map((route, index) => (
      <Paper key={index} style={{ padding: '25px', marginBottom: '10px' }}>
        <Grid container spacing={2}>
          <Grid item xs={11}>
            <Field
              fullWidth
              disabled={readOnly}
              label='SMSC'
              name={`${route}.smscId`}
              component={SelectFormField}
            >
              { smscIdList.map(smscId => (
                <MenuItem key={smscId} value={smscId}>{smscId}</MenuItem>
              ))}
            </Field>
          </Grid>
          <Grid item xs={1}>
            <IconButton
              disabled={readOnly}
              onClick={() => fields.remove(index)}
              style={{ marginTop: '7px' }}
            >
              <DeleteForeverIcon />
            </IconButton>
          </Grid>
          <Grid item xs={12}>
            <Field
              fullWidth
              disabled={readOnly}
              name={`${route}.receiverRegexes`}
              label='Numbers range'
              placeholder='e.g. 491573598922[4-9]'
              component={MultiTextFormField}
            />
          </Grid>
        </Grid>
      </Paper>
    ))}
  </div>
);

const EsmeRoutingFields = (props: {
  readonly smscIdList: string[];
  readonly readOnly: boolean;
}) => {
  const { smscIdList, readOnly } = props;

  return (
    <Grid container spacing={4} style={{ paddingTop: 20 }}>
      <Grid item xs={12}>
        <Field
          format={(value: String) => value || []}
          fullWidth
          disabled={readOnly}
          label='Default SMSCs'
          name='user.defaultSmscIds'
          component={SelectFormField}
          multiple={true}
        >
          { smscIdList.map(smscId => (
            <MenuItem key={smscId} value={smscId}>{smscId}</MenuItem>
          ))}
        </Field>
      </Grid>
      <Grid item xs={12}>
        <FieldArray
          name='mtRoutes'
          component={renderMtRouting}
          readOnly={readOnly}
          smscIdList={smscIdList}
        />
      </Grid>
      <Grid item xs={12}>
        <FieldArray
          name='moRoutes'
          component={renderMoRouting}
          readOnly={readOnly}
          smscIdList={smscIdList}
        />
      </Grid>
    </Grid>
  );
};

export default EsmeRoutingFields;
